import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, BookOpen, Users, ShoppingCart, LogOut, BarChart, FolderTree } from 'lucide-react';

function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  // Helper to determine active link based on query param
  const getActiveClass = (tab) => {
    const searchParams = new URLSearchParams(location.search);
    const currentTab = searchParams.get('tab') || 'overview';
    return currentTab === tab ? 'active' : '';
  };

  return (
    <div className="flex min-h-screen bg-stone-50">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-slate-200 flex flex-col">
        <div className="p-6 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center">
              <BookOpen className="w-6 h-6 text-white" />
            </div>
            <span className="text-xl font-extrabold text-slate-900">Lumina Admin</span>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          <Link to="/admin?tab=overview" className={`sidebar-link ${getActiveClass('overview')}`} data-testid="admin-dashboard-link">
            <LayoutDashboard className="w-5 h-5" />
            <span>Dashboard</span>
          </Link>
          <Link to="/admin?tab=courses" className={`sidebar-link ${getActiveClass('courses')}`} data-testid="admin-courses-link">
            <BookOpen className="w-5 h-5" />
            <span>Courses</span>
          </Link>
          <Link to="/admin?tab=categories" className={`sidebar-link ${getActiveClass('categories')}`} data-testid="admin-categories-link">
            <FolderTree className="w-5 h-5" />
            <span>Categories</span>
          </Link>
          <Link to="/admin?tab=users" className={`sidebar-link ${getActiveClass('users')}`} data-testid="admin-users-link">
            <Users className="w-5 h-5" />
            <span>Users</span>
          </Link>
          <Link to="/admin?tab=purchases" className={`sidebar-link ${getActiveClass('purchases')}`} data-testid="admin-analytics-link">
            <ShoppingCart className="w-5 h-5" />
            <span>Purchases</span>
          </Link>
        </nav>

        <div className="p-4 border-t border-slate-200">
          <div className="mb-3 text-sm text-slate-600">
            <div className="font-semibold text-slate-900">{user?.name}</div>
            <div className="text-xs">{user?.email}</div>
          </div>
          <button
            onClick={handleLogout}
            className="sidebar-link w-full text-red-600 hover:bg-red-50"
            data-testid="admin-logout-button"
          >
            <LogOut className="w-5 h-5" />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
